import React, {Component} from 'react';

export class TableToggleSection extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isExpanded: this.props.isExpanded
        };

        this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle() {
        this.setState({
            isExpanded: !this.state.isExpanded
        })

        this.props.onToggle()
    }

    render() {
        const text = this.state.isExpanded ? '--v' : '-->';
        return <tr data-id="0">
            <td colSpan={this.props.tableColumns} className="row-loader section-toggle">
                <a onClick={this.handleToggle}>{this.props.text} {text}</a>
            </td>
        </tr>;
    }
}
